export enum BookingType {
    COURSE = 'COURSE',
    EXAM = 'EXAM',
    EXTENSION = 'EXTENSION',
}
